import { Grid } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import { memo } from "react";
import MxFormL3RushSwitchField from "@rf-l3/form/MxFormL3RushSwitchField";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { A_CURRENCY } from "@/src-refactor/modules/shared/model/const/currency.conts";
import MxFormL3TextThousandField from "@rf-l3/form/MxFormL3TextThousandField";
import MxFormL3AutoComplete from "@rf-l3/form/MxForml3AutoComplete";
import { A_COMMISSION_RENT_ALL } from "@/src-refactor/modules/shared/model/const/property/comission_rent.const";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";
import usePropertyFormHelp from "../../../../hooks/helps/usePropertyFormHelp";

const PriceDataFormSection = () => {
  const { BUSINESS_TYPE } = usePropertyFormHelp();

  return (
    <Grid container spacing={2}>
      <Grid container item xs={12}>
        <MxFormSubTitle label="Precio" />
      </Grid>

      {(BUSINESS_TYPE.isSaleAndRent || BUSINESS_TYPE.isSale) && (
        <Grid container item xs={12} md={6} spacing={0.5}>
          <Grid item xs={12} sm={6} md={4}>
            <MxFormL3RushSwitchField
              name={CPropertyFormKeys.currency_sale_property}
              items={A_CURRENCY}
              withreacthookform={1}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={8}>
            <MxFormL3TextThousandField
              label="Precio de venta"
              name={CPropertyFormKeys.price_sale_property}
              withreacthookform={1}
            />
          </Grid>
        </Grid>
      )}

      {(BUSINESS_TYPE.isSaleAndRent || BUSINESS_TYPE.isRent) && (
        <Grid container item xs={12} md={6} spacing={0.5}>
          <Grid item xs={12} sm={6} md={4}>
            <MxFormL3RushSwitchField
              withreacthookform={1}
              items={A_CURRENCY}
              name={CPropertyFormKeys.currency_rent_property}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={8}>
            <MxFormL3TextThousandField
              withreacthookform={1}
              label="Precio de alquiler"
              name={CPropertyFormKeys.price_rent_property}
            />
          </Grid>
        </Grid>
      )}

      <Grid container item xs={12} md={6} spacing={0.5}>
        <Grid item xs={12} sm={6} md={4}>
          <MxFormL3RushSwitchField
            withreacthookform={1}
            name={CPropertyFormKeys.currency_maintenance_property}
            items={A_CURRENCY}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={8}>
          <MxFormL3TextThousandField
            withreacthookform={1}
            label="Precio de mantenimiento"
            name={CPropertyFormKeys.price_maintenance_property}
          />
        </Grid>
      </Grid>

      {(BUSINESS_TYPE.isRent ||
        BUSINESS_TYPE.isSaleAndRent ||
        BUSINESS_TYPE.isSale) && (
        <Grid item xs={12}>
          <MxFormSubTitle label=" Honorarios profesionales" />
        </Grid>
      )}

      {(BUSINESS_TYPE.isSale || BUSINESS_TYPE.isSaleAndRent) && (
        <Grid item xs={12} lg={4} md={4} sm={6}>
          <MxFormL3TextThousandField
            name={CPropertyFormKeys.fee_sale_percentage_commission_property}
            label="Porcentaje de comisión"
            suffix="%"
            withreacthookform={1}
          />
        </Grid>
      )}

      {(BUSINESS_TYPE.isSale || BUSINESS_TYPE.isSaleAndRent) && (
        <Grid item xs={12} lg={4} md={4} sm={6}>
          <MxFormL3TextThousandField
            name={CPropertyFormKeys.fee_sale_selling_agent_commission_percentage}
            label="Porcentaje de comisión agente vendedor"
            suffix="%"
            withreacthookform={1}
          />
        </Grid>
      )}

      {(BUSINESS_TYPE.isRent || BUSINESS_TYPE.isSaleAndRent) && (
        <Grid item xs={12} lg={4} md={4} sm={6}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            name={CPropertyFormKeys.fee_rent}
            label="Comisión por alquiler"
            items={A_COMMISSION_RENT_ALL}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default memo(PriceDataFormSection);
